/****************************************************************************************
 * Copyright (c) 2023. Peter Lemke, SV-Studios                                          *
 * This File, its contents and by extension the corresponding project is property of    *
 * SV-Studios and may not be used without explicit permission to do so.                 *
 *                                                                                      *
 * management@sv-studios.net                                                            *
 ****************************************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";
import { LoginState } from "../../Utils";

const authSlice = createSlice({
  name: "auth",
  initialState: { status: LoginState.loading, user: {}, apiKey: {}, loginProvider: [] },
  reducers: {
    login(state) {
      state.status = LoginState.authenticated;
    },
    logout(state) {
      state.status = LoginState.unauthenticated;
      state.user = {};
      state.apiKey = {};
    },
    setUser(state, action) {
      state.user = action.payload;
      Sentry.setUser({ username: action.payload?.username, id: action.payload?.id });
    },
    setApiKey(state, action) {
      state.apiKey = action.payload;
    },
    setLoginProvider(state, action) {
      state.loginProvider = action.payload;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
